import React, { Component } from 'react';
import { ServiceCollectionParam } from "./ServiceCollection";

type Props = { username: string }

interface State {
    username: string,
    password: string
}

export default class DbInfoPage extends Component<ServiceCollectionParam & Props, State> {

    state = {
        username: '',
        password: ''
    };

    async componentDidMount() {
        const username = this.props.username;

        const userResult = await this.props.services.dao.getProjectResultFor(username);

        if (userResult.dbCredentials) {
            const [username, password] = userResult.dbCredentials.split(';');

            this.setState({ username, password });
        }
    }

    async putListToClipboard() {
        const dtos = await this.props.services.dao.findDbPasses();

        const lines = dtos.map(dto => dto.username + ' ' + dto.password);

        await navigator.clipboard.writeText(lines.join("\n") + "\n");
    }

    async createDatabase() {

        const username = this.props.username;

        const userResult = await this.props.services.dao.getProjectResultFor(username);

        if (!userResult._id) {
            return;
        }

        const credentials = await this.props.services.dao.createDbForUser(username);

        this.setState({ username: credentials.username,
                        password: credentials.password });
    }

    render() {
        let isAdmin = this.props.services.uiSettings.isAdmin;

        return (
            <>
            <table className="table table-sm caption-top user-dashboard">
                <caption>Andmebaasiga ühendumise info</caption>
                <thead>
                <tr>
                    <th scope="col">Server</th>
                    <th scope="col">Kasutajanimi</th>
                    <th scope="col">Salasõna</th>
                    <th scope="col">Andmebaas</th>
                </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>db.mkalmo.eu</td>
                        <td>{ this.state.username }</td>
                        <td>{ this.state.password }</td>
                        <td>{ this.state.username }</td>
                    </tr>
                </tbody>
            </table>

            { <button className="btn-primary"
                      onClick={ () => this.createDatabase() }
                      type="button">Loo uus andmebaas</button>
            }

            <br /><br />

            { isAdmin && <button className="btn-primary"
                                 onClick={ () => this.putListToClipboard() }
                                 type="button">Kopeeri List</button>
            }

            </>
        );
    }

}
